<script lang="ts" setup>
import { useBasketStore } from '@/store/basket/basket'
import { SetTimePayload } from '@/store/basket/basket.types'
import { useBasketPaymentMethodsStore } from '@/store/basket/basket-payment-methods'
import { useBasketTimeStore } from '@/store/basket/basket-time'

import { TabTypes } from '@/types/components/basket-time.types'

import BasketTimeInfo from '@/components/Basket/basket-time/BasketTimeInfo.vue'
import BasketTimeTabActive from '@/components/Basket/basket-time/BasketTimeTabActive.vue'
import BasketTimeTabs from '@/components/Basket/basket-time/BasketTimeTabs.vue'
import BasketSection from '@/components/Basket/basket-utils/BasketSection.vue'
import BasketTitle from '@/components/Basket/basket-utils/BasketTitle.vue'

const emit = defineEmits(['goToPrevStep'])

const basketStore = useBasketStore()
const basketTimeStore = useBasketTimeStore()
const { getPaymentMethods } = useBasketPaymentMethodsStore()

onMounted(() => {
  // Фетчим данные для "Как можно скорее"
  updateTime({ delivery_at_client: false })
})

const selectedTab = ref<TabTypes>(TabTypes.FAST)

watch(
  () => selectedTab.value,
  (tabValue) => {
    if (tabValue === TabTypes.FAST) {
      updateTime({ delivery_at_client: false })
    }
  },
)

const updateTime = async (data: SetTimePayload) => {
  await basketTimeStore.getAvailableTime(data)

  await basketStore.setTime({
    delivery_at: basketTimeStore.delivery_at,
    delivery_at_client: data.delivery_at_client,
  })

  await getPaymentMethods()
}

const isLoading = computed(
  () =>
    !basketTimeStore.delivery_at &&
    !basketTimeStore.error &&
    basketTimeStore.variants.length === 0,
)

const goToPrevStep = () => emit('goToPrevStep')
</script>

<template>
  <basket-section id="delivery_at" :loading="isLoading" class="basket-time">
    <div class="basket-time__title" @click="goToPrevStep">
      <the-icon name="arrow-left" />

      <span>Оформление заказа</span>
    </div>

    <basket-title title="Время" />

    <basket-time-tabs v-model="selectedTab" class="basket-time__tabs" />

    <basket-time-tab-active
      :selected-tab="selectedTab"
      :error-message="basketTimeStore.error"
      :warning-message="basketTimeStore.warning"
      :warning-icon="basketTimeStore.warning_icon"
      @update-time="updateTime"
    />

    <div v-if="isLoading" class="basket-time__loader">
      <the-loader />
    </div>

    <transition v-else-if="basketTimeStore.delivery_at" name="height">
      <basket-time-info />
    </transition>
  </basket-section>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/animations.scss' as *;

.basket-time {
  min-height: 250px;

  &__title {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 800;
  }

  &__tabs {
    margin-bottom: 30px;
  }

  &__loader {
    position: relative;
    height: 24px;
  }

  &__items {
    margin-top: 24px;
  }
}
</style>
